import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CompanyMappingSearchPage = withSuspense(lazy(() => import('./company-mapping-search')));
export default CompanyMappingSearchPage;
